module.exports = __webpack_public_path__ + "static/img/dq9.0d9f097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq9.png
// module id = 1ip4
// module chunks = 0